import './label.css';
export default {
  "button": "pf-v6-c-button",
  "label": "pf-v6-c-label",
  "labelActions": "pf-v6-c-label__actions",
  "labelContent": "pf-v6-c-label__content",
  "labelIcon": "pf-v6-c-label__icon",
  "labelText": "pf-v6-c-label__text",
  "modifiers": {
    "blue": "pf-m-blue",
    "red": "pf-m-red",
    "orange": "pf-m-orange",
    "orangered": "pf-m-orangered",
    "yellow": "pf-m-yellow",
    "green": "pf-m-green",
    "teal": "pf-m-teal",
    "purple": "pf-m-purple",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "danger": "pf-m-danger",
    "info": "pf-m-info",
    "custom": "pf-m-custom",
    "compact": "pf-m-compact",
    "filled": "pf-m-filled",
    "outline": "pf-m-outline",
    "editable": "pf-m-editable",
    "editableActive": "pf-m-editable-active",
    "overflow": "pf-m-overflow",
    "add": "pf-m-add",
    "clickable": "pf-m-clickable",
    "disabled": "pf-m-disabled"
  }
};